import { render, staticRenderFns } from "./DetallesCuenta.vue?vue&type=template&id=1369e6c6&"
import script from "./DetallesCuenta.vue?vue&type=script&lang=js&"
export * from "./DetallesCuenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports